import React, { memo, useState, useCallback, useRef, useEffect } from 'react';

import JoditEditor from 'jodit-react';
import { size, isFunction } from 'lodash';

const RichEditor = ({
  initialValue,
  onChange,
  onBlur,
  maxCharacters = 1000,
}) => {
  const editor = useRef(null);
  const [content, setContent] = useState(null);
  const [config] = useState({
    readonly: false,
    toolbar: true,
    uploader: {
      insertImageAsBase64URI: true,
    },
    limitChars: maxCharacters,
    width: '100%',
  });

  const handleChange = useCallback(
    (state) => {
      if (size(state) <= 0) state = '<p></p>';

      setContent(state);
      onChange(state);
    },
    [onChange],
  );

  const handleBlur = () => {
    isFunction(onBlur) && onBlur();
  };

  useEffect(() => {
    setContent(initialValue);
  }, [initialValue]);

  return (
    <JoditEditor
      ref={editor}
      tabIndex={1}
      value={content}
      config={config}
      onBlur={handleBlur}
      onChange={handleChange}
    />
  );
};

export default memo(RichEditor);
